import { BaseApiRouteService } from "mrb/core";

class LoadioStoreFeaturedSectionFileStreamApiRouteService extends BaseApiRouteService {
    constructor() {
        super("store-loadio-featured-section-file-streams");
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?width,height}`, id, options);
    }

    getFeaturedSectionCoverImageByItemId(featuredSectionItemId, options) {
        return super.get(
            `${this.base}/store-featured-section-item-cover/{featuredSectionItemId}{?width,height}`,
            featuredSectionItemId,
            options
        );
    }
}

export default LoadioStoreFeaturedSectionFileStreamApiRouteService;
